export default __webpack_public_path__ + "static/media/advanced-stacking.b94c21ac.jpg";